import React from 'react'

import * as TtForms from '@23/react-forms'

import { useParticipant } from '../../../../../webrtc/webRTCRoom'
import type { FocusConfiguration } from '../../FocusConfigurator'

interface FocusPanelModeParticipantOptionProps {
  id: number
  side: 'left' | 'right'
  type: 'Participant' | 'Screen'
}

const FocusPanelModeParticipantOption = ({
  id,
  side,
  type,
}: FocusPanelModeParticipantOptionProps) => {
  const participant = useParticipant(id)

  return (
    <TtForms.Option<FocusConfiguration>
      name={`${side}Panel${type}Ids`}
      value={id}
    >
      {participant?.name ?? id}
    </TtForms.Option>
  )
}

export { FocusPanelModeParticipantOption }
